import React from 'react';
import { Text } from '@custom-components';
import { ReactChildrenPropType } from '../../lib/commonPropTypes';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.info(info);
    console.error(error);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Text.CopyBody align="center">An unrecoverable error has occurred, please go back and try again.</Text.CopyBody>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: ReactChildrenPropType.isRequired
};

const withErrorBoundary = () => (Component) =>
  function Error(props) {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };

export default withErrorBoundary;
